import React, { useEffect, useState } from "react";
import { getApiUrl } from "../../api";
import marubitLogo from "../../assets/images/marubit_logo.png";

interface CompanyInfo {
  company_name: string;
  phone: string;
  email: string;
}

export default function Footer() {
  const [company, setCompany] = useState<CompanyInfo | null>(null);

  useEffect(() => {
    (async () => {
      try {
        const res = await fetch(getApiUrl("/marubit/api/company/detail"));
        if (!res.ok) return;
        const data = await res.json();
        setCompany(data);
      } catch (e) {
        console.error("회사 정보 로딩 실패:", e);
      }
    })();
  }, []);

  return (
    <footer className="bg-[#3d3d3d] px-6 py-7">
      <div className="max-w-[1200px] mx-auto flex flex-col md:flex-row items-center justify-center gap-4 md:gap-[200px]">

        {/* 로고 */}
        <img
          src={marubitLogo}
          alt="마루빛"
          className="h-10 w-auto opacity-80 brightness-0 invert"
        />

        {/* 회사 정보 */}
        <div className="text-center md:text-left">
          {company && (
            <>
              <p className="m-0 mb-1 text-[13px] text-[#ccc] leading-relaxed">
                <span className="mr-8">대표번호 : {company.phone}</span>
                <span>이메일 : {company.email}</span>
              </p>
              <p className="m-0 mb-1 text-[13px] text-[#ccc] leading-relaxed">
                {company.company_name}
              </p>
            </>
          )}
          <p className="m-0 text-[12px] text-[#888] leading-relaxed">
            COPYRIGHT © {company?.company_name ?? "마루빛"}. ALL RIGHTS RESERVED.
          </p>
        </div>

      </div>
    </footer>
  );
}